import { atom } from 'jotai';

export const teacherSubAtom = atom('');
